import GameModel from 'Models/GameModel';
import axios from 'axios';
import AppModel from 'Models/AppModel';
import { mutateEntity, mutateNestedEntity } from 'Root/store/components/commonMutations';

const { API_URI } = AppModel;

export default {
  state() {
    return {
      activeGame: null,
      activeCategory: null,
      activeArticle: null,
      headerInfo: null,
      articles: {
        result: [],
        total: 0,
      },
      categories: {
        result: [],
        total: 0,
      },
      filter: {},
      popularArticles: [],
      searchResult: [],
      author: null,
    };
  },

  getters: {
    getterCategoryBySlug: (state) => (slug, gameId) => state.categories.result
      .find((category) => category.game_id === gameId && category.slug === slug),
  },

  mutations: {
    setAuthor(state, author) {
      state.author = author;
    },

    mutateActiveGame(state, idOrNamespace) {
      const gameModelKey = Number.isNaN(parseInt(idOrNamespace, 10)) ? 'ROUTE_TO_DATA' : 'ID_TO_DATA';
      const newGame = GameModel[gameModelKey][idOrNamespace];

      if (!newGame) {
        state.activeGame = null;
        return;
      }

      if (state.activeGame?.id === newGame.id) {
        return;
      }

      state.activeGame = GameModel[gameModelKey][idOrNamespace];
    },

    pruneArticles(state) {
      state.articles.result = [];
      state.articles.total = 0;
    },

    mutateEntity,

    mutateNestedEntity,
  },

  actions: {
    getBlogCategories({ commit }, params) {
      return axios.get(`${AppModel.API_URI}/blog_categories/list`, {
        params,
      })
        .then(({ data }) => {
          commit('mutateEntity', { entity: 'categories', data });
        });
    },

    fetchAuthor({ commit }, authorSlug) {
      return axios.get(`${API_URI}/blog_authors/${authorSlug}`)
        .then(({ data }) => {
          commit('setAuthor', data.result);
        });
    },
  },

  namespaced: true,
};
